import { createApp } from "vue"

import shortenInput from "./shorten-input"
import linksContainer from "./links-container"

import "./ui"

const shortenInputApp = createApp(shortenInput)
const linksContainerApp = createApp(linksContainer)
shortenInputApp.mount(document.querySelector(".shorten-link-container .input-container"))
linksContainerApp.mount(document.querySelector(".shorten-link-container .links-container"))
